import React from 'react';
import classnames from 'classnames';

import logo from './../../img/lr-logo-footer.svg';
import baseStyles from 'custom/base.styl';
import styles from 'custom/layout.styl';
import grid from './../../styles/grid.styl';

export default (props) => {
  const currnetYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={classnames(grid.space_between, grid.row)}>
          <div className={classnames(grid.col_6, baseStyles.copy)}>
            <img src={logo} className={baseStyles.logo} alt="logo" />
            <p>2009-{currnetYear} © Livingston-research.com. <span>All rights reserved</span></p>
          </div>
          <div className={classnames(grid.col_6, baseStyles.links, baseStyles.right)}>
            <ul>
              <li>
                <span>Contact dedicated support for applicants </span><span>(replies within 24 hours on business days):</span><br className={baseStyles.mobile_hide} />
                <a href="mailto:recruiting.team@liv-research.com">recruiting.team@liv-research.com</a>
              </li>
              <li>
                <i className={baseStyles.devider} />
              </li>
              <li><a href="http://livingston-research.com/freelancer/faq" target="_blank" rel="noopener noreferrer">FAQ</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};



// WEBPACK FOOTER //
// ./src/custom/livres/Footer.js